__turbopack_context__.v({
  "inFlow": "stickycta-module-scss-module__2TzB3W__inFlow",
  "stickybar": "stickycta-module-scss-module__2TzB3W__stickybar",
});
